import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'checkedDependent',
    'disabledDependent',
    'enabledDependent',
    'trigger',
  ]

  checkedDependentTargetConnected(dependent) {
    dependent.addEventListener('change', () => { this.#checkDependent(dependent) })
    dependent.dispatchEvent(new Event('change'), { bubbles: true  })
  }

  triggerTargetConnected(trigger) {
    trigger.addEventListener('change', () => this.#apply(trigger))
    trigger.dispatchEvent(new Event('change'), { bubbles: true  })
  }

  #apply(trigger) {
    this.enabledDependentTargets.forEach((input) => {
      input.disabled = !trigger.checked
    })

    this.disabledDependentTargets.forEach((input) => {
      input.disabled = trigger.checked
    })

    this.checkedDependentTargets.forEach((input) => {
      if (trigger.checked && String(input.dataset.checkWithParent).toLowerCase() === 'true') {
        input.checked = true
      } else if (trigger.checked === false) {
        input.checked = false
        input.dispatchEvent(new Event('change'), { bubbles: true  })
      }
    })
  }

  #checkDependent(dependent) {
    if (dependent.checked) {
      this.triggerTarget.checked = true
      this.triggerTarget.dispatchEvent(new Event('change'), { bubbles: true  })
    }
  }
}
